module.exports = __webpack_public_path__ + "static/media/463e9d14.jpg";